<template>
  <b-tab title="ТИПОВОЙ договор на ТО">
    <HeaderBlock :docHistory.sync="docHistory" class="mb-4" />
    <Block_8 :docHistory.sync="docHistory" class="mb-4" />
    <Block_9 :docHistory.sync="docHistory" class="mb-4" />
    <!-- <Application_1 :docHistory.sync="docHistory" class="mb-4" />
    <Application_2 :docHistory.sync="docHistory" class="mb-4" />
    <Application_3 :docHistory.sync="docHistory" class="mb-4" /> -->
    <Add_Application :docHistory.sync="docHistory" class="mb-4" />
  </b-tab>
</template>

<script>
import HeaderBlock from '@components/companies/contracts/typdog/HeaderBlock';
import Block_8 from '@components/companies/contracts/typdog/Block_8';
import Block_9 from '@components/companies/contracts/typdog/Block_9';
// import Application_1 from '@components/companies/contracts/typdog/Application_1';
// import Application_2 from '@components/companies/contracts/typdog/Application_2';
// import Application_3 from '@components/companies/contracts/typdog/Application_3';
import Add_Application from '@components/companies/contracts/typdog/Add_Application';

export default {
  components: {
    HeaderBlock,
    Block_8,
    Block_9,
    // Application_1,
    // Application_2,
    // Application_3,
    Add_Application,
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
}
</script>

